// extracted by mini-css-extract-plugin
module.exports = {"img":"gallery1_img__1V3PH"};